export const UNKNOWN_MENU_INDEX = -1;
export const BUSINESS_LINK = "/business.html";
